import { createSelector } from 'reselect';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { getState } from './state';
import { getList } from './identity';
import { PROMOTIONS_STREAM_ID } from '../../constants';
import { getDrawerStreamId } from '../../utils';
import { getActiveFolder } from './options';
export const getHasGroups = createSelector([
    getState,
    getList
], (state, list)=>{
    var _state_drawer;
    return ((_state_drawer = state.drawer) === null || _state_drawer === void 0 ? void 0 : _state_drawer.hasGroups) || list.length > 1;
});
export const getHasUnread = createSelector([
    getList
], (list)=>list.some((item)=>item.newCount && item.newCount > 0));
export const getUnreadCount = createSelector([
    getList
], (list)=>list.reduce((acc, curr)=>acc + curr.newCount, 0));
export const getDrawerElninos = (state)=>{
    var _streamSelectors_getItems;
    return (_streamSelectors_getItems = streamSelectors.getItems(state, PROMOTIONS_STREAM_ID)) !== null && _streamSelectors_getItems !== void 0 ? _streamSelectors_getItems : [];
};
export const getActiveDrawerStreamParams = createSelector([
    getActiveFolder
], (folder)=>({
        folder
    }));
export const getActiveDrawerStreamId = createSelector([
    getActiveDrawerStreamParams
], (params)=>getDrawerStreamId(params));
export const isDrawerEmpty = createSelector([
    (state)=>state,
    getActiveDrawerStreamId
], (state, streamId)=>{
    if (!streamId) {
        return false;
    }
    if (!streamSelectors.isInitialized(state, streamId)) {
        return false;
    }
    const stream = streamSelectors.getStream(state, streamId);
    return stream.items.length === 0 && !stream.isFetching && !stream.hasMore;
});
export const getLatestTs = createSelector([
    (state)=>state,
    getActiveDrawerStreamId
], (state, streamId)=>{
    var _stream_items__bucket, _stream_items_;
    if (!streamId) {
        return false;
    }
    if (!streamSelectors.isInitialized(state, streamId)) {
        return false;
    }
    const stream = streamSelectors.getStream(state, streamId);
    return (_stream_items_ = stream.items[0]) === null || _stream_items_ === void 0 ? void 0 : (_stream_items__bucket = _stream_items_.bucket) === null || _stream_items__bucket === void 0 ? void 0 : _stream_items__bucket.ts;
});
export const getReplyMessageTypeFromDrawerStream = createSelector([
    (state)=>state,
    getActiveDrawerStreamId,
    (state, messageId)=>messageId
], (state, streamId, messageId)=>{
    if (!streamId) {
        return false;
    }
    if (!streamSelectors.isInitialized(state, streamId)) {
        return false;
    }
    const stream = streamSelectors.getItems(state, streamId);
    const drawerItem = stream.find((item)=>{
        var _item_message;
        return (item === null || item === void 0 ? void 0 : (_item_message = item.message) === null || _item_message === void 0 ? void 0 : _item_message.messageId) === messageId;
    });
    if (!drawerItem) {
        return false;
    }
    return drawerItem.message.type;
});

//# sourceMappingURL=drawer.js.map